document.addEventListener('DOMContentLoaded', () => {
  let swiperInstance;

  const gallerySlider = () => {
    swiperInstance = new Swiper('.image-scroller__swiper', {
      slidesPerView: 3,
      watchOverflow: true,
      spaceBetween: 50,
      loop: true,
      speed: 3000,
      observer: true,
      observeParents: true,
      autoplay: {
        delay: 1,
        disableOnInteraction: false
      },
      breakpoints: {
        1260: {
          autoplay: false,
          loop: false,
          slidesPerView: 7
        },
        999: {
          slidesPerView: 5
        },
        768: {
          slidesPerView: 4,
          speed: 3000
        }
      }
    });
  };

  gallerySlider();


  let resizeTimeout;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        gallerySlider();
      }
    }, 100);
  });
});